export default {
    getGroups:        { method: 'get',    url: 'groups' },
    postGroups:       { method: 'post',   url: 'groups' },
    putGroups:        { method: 'put',    url: 'groups/{id}' },
    deleteGroups:     { method: 'delete', url: 'groups/{id}' },
    getGroupTrail:    { method: 'get',    url: 'groups/{id}/trail' },
    linkGroupTrail:   { method: 'post',   url: 'groups/{id}/trail' },
    unlinkGroupTrail: { method: 'delete', url: 'groups/{id}/trail/{otherGroupId}' },
}
